module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/full-print/7-d5c485d481d319067de4b209ca980ab7.jpg";